import { useDispatch } from 'react-redux';

import { NumberRangeQuestion } from 'src/lib/flow/FlowQuestion';
import { changeAnswers } from 'src/store/sellerInput';

import NumberRangeInput from '../sellerFlow/NumberRangeInput';

type NumberRangeInputFieldProps = {
  question: NumberRangeQuestion;
  value: {
    min?: string;
    max?: string;
  };
};

const NumberRangeInputField: React.FC<NumberRangeInputFieldProps> = ({ question, value }) => {
  const dispatch = useDispatch();
  const { key, maxValue, minValue, maxLabel, minLabel, optional } = question;

  const onChange = (key: string, newAnswer: { min?: string; max?: string }, hasError = false) => {
    if (!hasError) {
      dispatch(changeAnswers([{ key, answer: newAnswer }]));
    }
  };

  return (
    <NumberRangeInput
      name={key}
      value={value}
      onChange={onChange}
      max={typeof maxValue === 'string' ? parseInt(maxValue) : maxValue}
      min={minValue}
      maxPlaceholder={maxLabel}
      minPlaceholder={minLabel}
      required={!optional}
    />
  );
};

export default NumberRangeInputField;
